import type { Voucher } from '@src/domains/vouchers/types/voucher';

export function voucherHasResources(vouchers: Voucher[]): boolean {
  return vouchers.some((voucher) => voucher.resources.length);
}
